<template>
  <div class="contract-remark">
    <el-input
      v-if="isEditing"
      ref="inputRef"
      v-model="currentValue"
      size="small"
      maxlength="20"
      @blur="handleBlur"
      @keyup.enter.native="$event.target.blur()"
    />
    <span
      v-else
      class="remark-text"
      :class="{ 'is-empty': !currentValue }"
      @click="startEdit"
    >
      {{ currentValue || '点击输入备注' }}
      <i v-if="currentValue" class="el-icon-edit" style="margin-left: 4px" />
    </span>
  </div>
</template>

<script>
</script>

<script setup>
import { ref, watch, nextTick } from 'vue'
import { updateContractRemark } from '@/api/domain/carsService'
import { Message } from 'element-ui'

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
  contractNo: {
    type: String,
    required: true,
  },
  contractId: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['success'])

const isEditing = ref(false)
const currentValue = ref(props.value)
const inputRef = ref(null)

watch(
  () => props.value,
  (val) => {
    currentValue.value = val
  },
)

const startEdit = () => {
  isEditing.value = true
  nextTick(() => {
    inputRef.value.focus()
  })
}

const handleBlur = async () => {
  // If value hasn't changed, just stop editing
  if (currentValue.value === props.value) {
    isEditing.value = false
    return
  }

  try {
    const { code, msg } = await updateContractRemark({
      contractNo: props.contractNo,
      contractId: props.contractId,
      remark: currentValue.value,
    })

    if (code === 1) {
      Message.success('保存成功')
      emit('success', currentValue.value)
    } else {
      Message.error(msg || '保存失败')
      // eslint-disable-next-line require-atomic-updates
      currentValue.value = props.value // Revert
    }
  } catch (error) {
    Message.error('保存失败')
    // eslint-disable-next-line require-atomic-updates
    currentValue.value = props.value // Revert
  } finally {
    isEditing.value = false
  }
}
</script>

<style scoped>
.contract-remark {
  cursor: pointer;
  min-height: 23px;
}
.remark-text {
  display: inline-block;
  width: 100%;
  min-height: 23px;
  line-height: 23px;
}
.is-empty {
  color: #909399;
}
</style>
